/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Users_ProInputs */



/**
* | output |
* | --- |
* | "3 included, then $10/user" |
*
* @param {Signup_Compare_Users_ProInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_users_pro = /** @type {((inputs?: Signup_Compare_Users_ProInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Users_ProInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("3 inclus, puis 10 $/utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("3 inklusive, danach 10 $/Benutzer")
	if (locale === "it") return /** @type {LocalizedString} */ ("3 inclusi, poi 10 $/utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("3 включено, далее 10 $ за пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("3 incluidos, luego 10 $/usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("含 3 个，之后每用户 10 美元")
	if (locale === "ja") return /** @type {LocalizedString} */ ("3 人まで込み、以降 1 人あたり 10 ドル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("3 शामिल, फिर $10/उपयोगकर्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("3 incluídos, depois 10 $/utilizador")
	return /** @type {LocalizedString} */ ("3 included, then $10/user")
});